import { ClockIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

const PastConfirmedStrip = ({ count = 0, onReviewClick }) => {
  if (!count || count === 0) return null;

  return (
    <div className="flex items-center justify-between bg-white rounded-card shadow-hairline border border-ink-100 border-l-4 border-l-accent-500 px-4 py-3">
      <div className="flex items-center gap-x-2.5 min-w-0">
        <ClockIcon className="size-5 text-accent-500 flex-shrink-0" />
        <span className="inline-flex items-center justify-center size-5 rounded-full bg-accent-100 text-xs font-bold text-accent-700 flex-shrink-0">
          {count}
        </span>
        <p className="text-sm font-medium text-ink-900 truncate">
          {count === 1
            ? "1 past appointment needs a status update"
            : `${count} past appointments need a status update`}
        </p>
      </div>

      <button
        onClick={onReviewClick}
        aria-label={`Update ${count} past appointment${count === 1 ? "" : "s"}`}
        className="flex-shrink-0 inline-flex items-center gap-x-1 rounded-pill bg-accent-500 px-3 py-1.5 text-xs font-medium text-cream-50 hover:bg-accent-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500 transition-colors"
      >
        Review
        <ChevronRightIcon className="size-3.5" />
      </button>
    </div>
  );
};

export default PastConfirmedStrip;
